function ToggleButton(props: {
  classId?: string;
  id: string;
  label: string;
  onToggle: () => void;
  isActive: boolean;
}) {
  const label = () => props.label + (!props.isActive ? " disabled" : "");
  return (
    <div class="h-10 w-20 flex items-center">
      <label
        aria-label={label()}
        class={`flex items-center toggle cursor-highlight-pointer ${props.classId} text-sm`}
        for={props.id}
      >
        <input
          id={props.id}
          type="checkbox"
          aria-checked={props.isActive}
          checked={props.isActive}
          onChange={(e) => {
            e.stopPropagation();
            props.onToggle();
          }}
          class="mr-2" // Add some margin to the right of the checkbox
        />
        <span class="slider mr-2 cursor-highlight-pointer w-7 p-0" />
        {label()}
      </label>
    </div>
  );
}

export default ToggleButton;
